<!-- eslint-disable custom/no-inline-svg -->
<div
  class="dealiodesk-logo"
  [class.is-animated]="animated"
  [class.is-clickable]="clickable"
  [class.theme-dark]="theme === 'dark'"
  [attr.role]="clickable ? 'button' : 'img'"
  [attr.tabindex]="clickable ? 0 : null"
  [attr.aria-label]="ariaLabel"
  (click)="onActivate($event)"
  (keydown)="onActivate($event)"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    [attr.viewBox]="viewBox"
    [attr.width]="computedWidth"
    [attr.height]="height"
    preserveAspectRatio="xMidYMid meet"
    focusable="false"
    aria-hidden="true"
  >
    <title>{{ ariaLabel }}</title>

    <!-- ICON: Zoodealio turtle mascot -->
    @if (variant === 'full' || variant === 'icon') {
      <g class="dd-mascot">
        <!--
          The turtle paths come from assets/img/Zoodealio-Logo.svg.
          Original coords use an inner translate(-10.284 -10) to align
          the shell top-left at ~(0,0). We wrap that with an outer
          transform that scales + centers the turtle into our icon area.

          Original visible bounds: ~(0,0) → (60, 40)
          After scale(1.5):        ~(0,0) → (90, 60)
          Centered in the icon slot with translate(5, 20).
        -->
        <g transform="translate(5 20) scale(1.5)">
          <g transform="translate(-10.284 -10)">
            <!-- Shell (green) -->
            <path
              class="dd-fill-green"
              d="M40.353,21.948h-.04a13.615,13.615,0,0,0-10.082-9.006l.956-1.4-2.922.365L28.655,10l-7.7,4.248h0a13.66,13.66,0,0,0-6.465,7.7h-.04a4.318,4.318,0,0,0,0,8.631h.085c.03.09.055.185.09.28h0c.07.175.145.355.215.535l.07.18C18.858,41.257,27.424,50,27.424,50s8.571-8.746,12.509-18.428l.07-.18c.07-.18.145-.355.215-.535h0c.035-.1.06-.19.09-.28h.085a4.318,4.318,0,0,0,0-8.631Z"
            />

            <!-- Face (white / light) -->
            <path
              class="dd-fill-face"
              d="M44.506,35.673a6.109,6.109,0,0,0-10.788-3.933,6.114,6.114,0,1,0-6.394,9.8,6.8,6.8,0,0,0-.08.966,6.475,6.475,0,1,0,12.949,0,6.8,6.8,0,0,0-.08-.966A6.119,6.119,0,0,0,44.506,35.673Z"
              transform="translate(-6.315 -9.772)"
            />

            <!-- Mouth / smile (wrapped so we can animate it) -->
            <g class="dd-mouth">
              <path
                class="dd-fill-green"
                d="M40.368,59.038A4.143,4.143,0,0,1,36.23,54.9a.54.54,0,1,1,1.081,0,3.057,3.057,0,1,0,6.114,0,.54.54,0,1,1,1.081,0A4.143,4.143,0,0,1,40.368,59.038Z"
                transform="translate(-12.964 -22.164)"
              />
            </g>

            <!-- Left eye — OPEN state (solid dot, mirrors the right eye).
                 Visible by default, fades out on hover. -->
            <g class="dd-eye dd-eye-left-open">
              <circle
                class="dd-fill-green"
                cx="22.8"
                cy="26.261"
                r="1.441"
              />
            </g>

            <!-- Left eye — WINK state (the arched brow from the original logo).
                 Hidden by default, fades in on hover. -->
            <g class="dd-eye dd-eye-left-wink">
              <path
                class="dd-fill-green"
                d="M35.338,41.878a.54.54,0,0,1-.54-.54,1.621,1.621,0,0,0-3.237,0,.54.54,0,1,1-1.081,0,2.7,2.7,0,0,1,5.4,0A.54.54,0,0,1,35.338,41.878Z"
                transform="translate(-10.091 -14.366)"
              />
            </g>

            <!-- Right eye (wrapped so scaleY animation pivots in place) -->
            <g class="dd-eye dd-eye-right">
              <circle
                class="dd-fill-green"
                cx="31.001"
                cy="26.261"
                r="1.441"
              />
            </g>

            <!-- Right flipper (white highlight on shell) -->
            <path
              class="dd-fill-face"
              d="M71.32,42.513a2.152,2.152,0,0,0,0-4.2,13.376,13.376,0,0,1,.175,2.061A13.74,13.74,0,0,1,71.32,42.513Z"
              transform="translate(-30.497 -14.145)"
            />

            <!-- Left flipper (white highlight on shell) -->
            <path
              class="dd-fill-face"
              d="M15.807,40.371a13.374,13.374,0,0,1,.175-2.061,2.152,2.152,0,0,0,0,4.2A13.74,13.74,0,0,1,15.807,40.371Z"
              transform="translate(-2.003 -14.145)"
            />
          </g>
        </g>
      </g>
    }

    <!-- WORDMARK (part of full lockup) -->
    @if (variant === 'full') {
      <g
        font-family="Inter, 'Helvetica Neue', Arial, sans-serif"
        font-weight="700"
        font-size="38"
        letter-spacing="-1.2"
      >
        <!-- "dealio" — Boa Blue -->
        <text class="dd-letter dd-fill-blue-dark" x="72"  y="62">d</text>
        <text class="dd-letter dd-fill-blue-dark" x="94"  y="62">e</text>
        <text class="dd-letter dd-fill-blue-dark" x="115" y="62">a</text>
        <text class="dd-letter dd-fill-blue-dark" x="137" y="62">l</text>
        <text class="dd-letter dd-fill-blue-dark" x="148" y="62">i</text>
        <text class="dd-letter dd-fill-blue-dark" x="159" y="62">o</text>

        <!-- "desk" — Primary Zoodealio Blue -->
        <text class="dd-letter dd-fill-blue" x="184" y="62">d</text>
        <text class="dd-letter dd-fill-blue" x="206" y="62">e</text>
        <text class="dd-letter dd-fill-blue" x="227" y="62">s</text>
        <text class="dd-letter dd-fill-blue" x="246" y="62">k</text>
      </g>
    }

    <!-- WORDMARK ONLY variant — tightly cropped (viewBox 0 0 198 52) -->
    @if (variant === 'wordmark') {
      <g
        font-family="Inter, 'Helvetica Neue', Arial, sans-serif"
        font-weight="700"
        font-size="38"
        letter-spacing="-1.2"
      >
        <!-- "dealio" — Boa Blue -->
        <text class="dd-letter dd-fill-blue-dark" x="0"   y="38">d</text>
        <text class="dd-letter dd-fill-blue-dark" x="22"  y="38">e</text>
        <text class="dd-letter dd-fill-blue-dark" x="43"  y="38">a</text>
        <text class="dd-letter dd-fill-blue-dark" x="65"  y="38">l</text>
        <text class="dd-letter dd-fill-blue-dark" x="76"  y="38">i</text>
        <text class="dd-letter dd-fill-blue-dark" x="87"  y="38">o</text>

        <!-- "desk" — Primary Zoodealio Blue -->
        <text class="dd-letter dd-fill-blue" x="112" y="38">d</text>
        <text class="dd-letter dd-fill-blue" x="134" y="38">e</text>
        <text class="dd-letter dd-fill-blue" x="155" y="38">s</text>
        <text class="dd-letter dd-fill-blue" x="174" y="38">k</text>
      </g>
    }
  </svg>
</div>
